import './styles.css';

import { ScrollColumnView } from '@ipfabric/ui-components/ScrollView/ScrollColumnView';
import { GraphHostToDefaultGWForm } from 'components/Graph/GraphSidePanel/GraphPathlookup/GraphHostToDefaultGWForm';
import type { HostToDefaultGWFormValues } from 'components/Graph/GraphSidePanel/GraphPathlookup/HostToDefaultGWFormValues';
import type { FormikProps } from 'formik';
import { type FC, useState } from 'react';
import { getPathLookupHostToDefaultGWFromLocalStorage } from './PathLookupLocalStorage';
import type { Vrf } from './fetchVrf';
import { useGraphPathlookupForm } from './useGraphPathlookupForm';

interface Props {
  formik: FormikProps<HostToDefaultGWFormValues>;
}

export const GraphHostToDefaultGW: FC<Props> = (props) => {
  const [vrf, setVrf] = useState<Vrf[]>([]);

  const localStoragePathlookupHostToDefaultGW =
    getPathLookupHostToDefaultGWFromLocalStorage();

  useGraphPathlookupForm({
    loadedFromLocalStorage: localStoragePathlookupHostToDefaultGW !== null,
    updateFieldValue: props.formik.setFieldValue,
    updateVrf: setVrf,
    vrf,
    vrfValue: props.formik.values.vrf,
    vrfIpError: props.formik.errors.startingPoint,
    vrfIpValue: props.formik.values.startingPoint,
  });

  return (
    <ScrollColumnView className='graph-pathlookup__content'>
      <GraphHostToDefaultGWForm formik={props.formik} vrf={vrf} />
    </ScrollColumnView>
  );
};
